import { useCallback, useEffect } from 'react';
import { FirebaseMessage, FirebaseMessageType } from '../../../types';
import { ref, remove, onValue } from 'firebase/database';
import { database } from './firebase-config';

const useFirebaseMessageHandler = (
  messageType: FirebaseMessageType[],
  firebasePath: string,
  handleMessageCallback: (message: FirebaseMessage) => void
) => {
  const handleMessage = useCallback(
    (message: FirebaseMessage, childKey: string) => {
      if (messageType.includes(message.type)) {
        handleMessageCallback(message);
      }

      // delete message after it's been handled
      const dbRef = ref(database, `${firebasePath}/${childKey}`);
      remove(dbRef);
    },
    [firebasePath, handleMessageCallback, messageType]
  );

  useEffect(() => {
    if (firebasePath === '') return;
    const dbRef = ref(database, firebasePath);

    const removeListener = onValue(dbRef, (snapshot) => {
      if (snapshot.val()) {
        snapshot.forEach((child) => {
          const keys = Object.keys(child.val());
          const key = keys[0];
          const value = child.val()[key];

          if (Array.isArray(value)) {
            value.forEach((element) => {
              handleMessage(element, child.key);
            });
          } else {
            handleMessage(value, child.key);
          }
        });
      }
    });

    return () => {
      removeListener();
    };
  }, [firebasePath, handleMessage]);
};

export default useFirebaseMessageHandler;
